import axios from "axios";
import { getTenantHeader } from "../embed/tenantHeader";

const setAccessToken = () => {
  const accessToken = localStorage.getItem("TOKEN");
  const employee = JSON.parse(localStorage.getItem("USER")) || null;

  if (accessToken && accessToken !== "null") {
    axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
  } else {
    delete axios.defaults.headers.common.Authorization;
  }

  axios.defaults.headers.common.apiCallerSource= `CHECKOUT`;
  axios.defaults.headers.common['BRTenant']= getTenantHeader();

  if (employee) {
    axios.defaults.headers.common.apiCallerId = employee?.employeeId;
  } else {
    delete axios.defaults.headers.common["apiCallerId"];
  }
};

const resolveAuthCredentials = () => {
  let clientId = process.env['REACT_APP_API_CLIENT'];
  let secret = process.env['REACT_APP_API_SECRET'];

  if (process.env.REACT_APP_CREDS) {
    try {
      const creds = JSON.parse(process.env.REACT_APP_CREDS);
      const tenant = getTenantHeader();
      const tenantKey = Object.keys(creds).find(
        (key) => key.toLowerCase() === String(tenant || '').toLowerCase(),
      );

      if (tenantKey && creds[tenantKey]) {
        clientId = creds[tenantKey].USERNAME;
        secret = creds[tenantKey].SECRET;
      }
    } catch (e) {
      // Fall back to default client credentials.
    }
  }

  return { clientId, secret };
};

const hasEmbeddedCredentials = () => {
  if (process.env.REACT_APP_API_SECRET) {
    return true;
  }

  if (process.env.REACT_APP_API_CLIENT) {
    return true;
  }

  if (process.env.REACT_APP_CREDS) {
    try {
      const creds = JSON.parse(process.env.REACT_APP_CREDS);
      return Object.values(creds).some((entry) => entry?.SECRET);
    } catch (e) {
      return false;
    }
  }

  return false;
};

const getEmbedAuthTokenUrl = () => {
  if (typeof document === 'undefined') {
    return null;
  }

  const scripts = document.querySelectorAll('script[src*="loader"], script[src*="store"]');

  for (const script of scripts) {
    if (!script.src) {
      continue;
    }

    try {
      const basePath = script.src.substring(0, script.src.lastIndexOf('/') + 1);
      return new URL('auth/token', basePath).href;
    } catch (e) {
      // Try the next script tag.
    }
  }

  return null;
};

const getAuthToken = () => {
  const embedAuthUrl = getEmbedAuthTokenUrl();
  const useEmbedProxy = embedAuthUrl && !hasEmbeddedCredentials();

  if (useEmbedProxy) {
    return axios.post(
      embedAuthUrl,
      {},
      {
        // Never set Authorization: undefined — axios sends the literal string "undefined"
        // and triggers a CORS preflight that fails against /embed/v1/auth/token.
        headers: {
          apiCallerSource: 'CHECKOUT',
          BRTenant: getTenantHeader(),
        },
      },
    );
  }

  const { clientId, secret } = resolveAuthCredentials();
  const baseUrl = process.env.REACT_APP_BASE_URL;

  return axios.post(
    baseUrl + "api/auth/token",
    { clientId, secret },
    {
      headers: {
        apiCallerSource: "CHECKOUT",
        BRTenant: getTenantHeader(),
      },
    },
  );
};
const ISSERVER = typeof window === "undefined";
if (!ISSERVER) {
  queueMicrotask(() => setAccessToken());
}

export default {
  get: axios.get,
  post: axios.post,
  put: axios.put,
  delete: axios.delete,
  patch: axios.patch,
  setAccessToken,
  getAuthToken,
};
